import { render, staticRenderFns } from "./knav.vue?vue&type=template&id=2209904a"
import script from "./knav.vue?vue&type=script&lang=js"
export * from "./knav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports